// extracted by mini-css-extract-plugin
export var desktopQuery = "screen and (min-width: 60rem)";
export var extraLargeDesktopQuery = "screen and (min-width: 120rem)";
export var headerDesktopQuery = "screen and (min-width: 64rem)";
export var hoverQuery = "(hover: hover)";
export var landscapeQuery = "(orientation: landscape)";
export var largeDesktopQuery = "screen and (min-width: 90rem)";
export var largeTabletQuery = "screen and (min-width: 48rem)";
export var maxExtraLargeDesktopScreen = "120rem";
export var maxHeaderMobileScreen = "64rem";
export var maxLargeDesktopScreen = "90rem";
export var maxLargeTabletScreen = "60rem";
export var maxMobileScreen = "30rem";
export var maxSmallTabletScreen = "48rem";
export var maxWideDesktopScreen = "80rem";
export var meridianInner = "cp_gL";
export var portraitQuery = "(orientation: portrait)";
export var reducedMotionQuery = "(prefers-reduced-motion)";
export var smallTabletQuery = "screen and (min-width: 30rem)";
export var wideDesktopQuery = "screen and (min-width: 80rem)";
export var wrapper = "cp_q";